import type { ColDef, GetQuickFilterTextParams, ValueGetterParams } from 'ag-grid-enterprise'
import type { IAppSummary } from '~/types/application'
import type { IAppManagementByDeviceType } from '~/types/application-management'

import { FASTLY_PATH } from '~/const/asset'
import { resize } from '~/utils/media'
import { applicationColDef } from '~/utils/table'

const columns: ColDef<IAppSummary>[] = [
  // NOTE: used by the search, DO NOT REMOVE THIS HIDDEN COLUMN
  {
    field: 'app_key',
    hide: true,
  },
  applicationColDef({
    field: 'default_display_name',
    flex: 1,
    getQuickFilterText: ({ data }: GetQuickFilterTextParams<IAppManagementByDeviceType>): string =>
      data?.default_display_name || '',
    tooltipField: 'default_display_name',
    valueGetter: ({ data }: ValueGetterParams<IAppManagementByDeviceType>): Record<string, string> | null => {
      if (!data) return null

      const { default_display_name, device_type, icon_file_id } = data

      return {
        app_icon_url: icon_file_id ? resize(`${FASTLY_PATH}${icon_file_id}`, 32, 32) : '',
        device_type,
        name: default_display_name || '',
      }
    },
  }),
]

export default columns
